'use strict'

adsenseAdsTemplate = require '../../footer.html.mustache'

module.exports = class AdsenseForSearchView extends Backbone.View
  render: (adsenseAdsHash) ->
    @$el.html adsenseAdsTemplate.render {adsenseAdsHash}

  loadAds: (query, currentPage) ->
    adsenseAdsContainerEl = @$el.find('#adsense-ads-container')

    return if adsenseAdsContainerEl.length == 0 || !window._googCsa?

    elementOptions =
      container: 'adsense-ads-container'
      width: '1000'
      number: 4
      colorDomainLink: '0088CC'
      colorText: '333333'
      colorTitleLink: '0088CC'
      adLayout: 'sellerFirst'
      longerHeadlines: false
      detailedAttribution: true

    pageOptions =
      adPage: currentPage
      pubId: 'livingsocial'
      query: query
      adtest: true
      domainLinkAboveDescription: false
      location: true
      sellerRatings: false
      consumerRatings: false
      siteLinks: true
      linkTarget: '_blank'
      adLoadedCallback: (containerName, adsLoaded) ->
        if (adsLoaded)
          adsenseAdsContainerEl.removeClass('hide-ads')
        else
          adsenseAdsContainerEl.addClass('hide-ads')

    window._googCsa('ads', pageOptions, elementOptions)